import classnames from "classnames";
import * as React from "react";

import Checkbox, { CheckboxProps } from "../../Checkbox";
import "./GreenBackgroundCheckbox.scss";

const GreenBackgroundCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      {...props}
      checkboxClassName={classnames(
        "GreenBackgroundCheckbox__checkbox",
        props.checkboxClassName
      )}
      checkboxSelectedClassName="GreenBackgroundCheckbox__checkbox--checked"
    />
  );
};

export default GreenBackgroundCheckbox;
